export function nonNullable<T>(arg: T | null | undefined): arg is T {
  return typeof arg !== 'undefined' && arg !== null
}

export function isString<T>(arg: T): arg is T {
  return typeof arg === 'string'
}

// https://stackoverflow.com/questions/47632622/typescript-and-filter-boolean
export type ExcludesFalse = <T>(x: T | false) => x is T
